function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getValidElementProps } from '../utils/htmlValidProps';
import { DEVICE_SIZES, IGNORE_SIZE } from '../utils/constants';
var gridArray = [true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
var propTypes = {
  /** Columns will align according to one of the possible string value options: `['auto', 'start', 'end', 'center', 'baseline', 'stretch']` */
  alignSelf: PropTypes.string,
  breakline: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,

  /**
     Column span for device sizes: 0 - 575px.
     Pass in a number from 1 to 12 or as a boolean.
     */
  xs: PropTypes.oneOf(gridArray),

  /**
     Column span for device sizes: 576 - 767px.
     Pass in a number from 1 to 12 or as a boolean.
     */
  sm: PropTypes.oneOf(gridArray),

  /**
     Column span for device sizes: 768 - 991px.
     Pass in a number from 1 to 12 or as a boolean.
     */
  md: PropTypes.oneOf(gridArray),

  /**
     Column span for device sizes: 992 - 1199px.
     Pass in a number from 1 to 12 or as a boolean.
     */
  lg: PropTypes.oneOf(gridArray),

  /**
     Column span for device sizes: 1200px and above.
     Pass in a number from 1 to 12 or as a boolean.
     */
  xl: PropTypes.oneOf(gridArray),

  /**
   * Hide column on xs
   */
  xsHidden: PropTypes.bool,

  /**
   * Hide column on sm
   */
  smHidden: PropTypes.bool,

  /**
   * Hide column on md
   */
  mdHidden: PropTypes.bool,

  /**
   * Hide column on lg
   */
  lgHidden: PropTypes.bool,

  /**
   * Hide column on xl
   */
  xlHidden: PropTypes.bool,

  /**
   * Offset number for columns from the left for xs
   */
  xsOffset: PropTypes.number,

  /**
   * Offset number for columns from the left for sm
   */
  smOffset: PropTypes.number,

  /**
   * Offset number for columns from the left for md
   */
  mdOffset: PropTypes.number,

  /**
   * Offset number for columns from the left for lg
   */
  lgOffset: PropTypes.number,

  /**
   * Offset number for columns from the left for xl
   */
  xlOffset: PropTypes.number,

  /**
   * Push columns for xs
   */
  xsPush: PropTypes.number,

  /**
   * Push columns for sm
   */
  smPush: PropTypes.number,

  /**
   * Push columns for md
   */
  mdPush: PropTypes.number,

  /**
   * Push columns for lg
   */
  lgPush: PropTypes.number,

  /**
   * Push columns for xl
   */
  xlPush: PropTypes.number,

  /**
     Pull columns for xs
     */
  xsPull: PropTypes.number,

  /**
     Pull columns for sm
     */
  smPull: PropTypes.number,

  /**
     Pull columns for md
     */
  mdPull: PropTypes.number,

  /**
     Pull columns for lg
     */
  lgPull: PropTypes.number,

  /**
     Pull columns for xl
     */
  xlPull: PropTypes.number
};
var defaultProps = {};

var Col = /*#__PURE__*/function (_Component) {
  _inherits(Col, _Component);

  var _super = _createSuper(Col);

  function Col() {
    _classCallCheck(this, Col);

    return _super.apply(this, arguments);
  }

  _createClass(Col, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alignSelf = _this$props.alignSelf,
          breakline = _this$props.breakline,
          children = _this$props.children,
          className = _this$props.className;
      var classes = [];
      var props = this.props;
      var colProps = getValidElementProps('div', props);
      DEVICE_SIZES.forEach(function (size) {
        function pushProp(propSuffix, modifier) {
          var base = propSuffix.length < 1 ? 'col-' : '';
          var propName = "".concat(size).concat(propSuffix);
          var propValue = props[propName];

          if (propValue != null) {
            if (typeof propValue === 'number' || typeof propValue === 'string') {
              var gridClass = "".concat(modifier).concat(base).concat(size, "-").concat(propValue);

              if (IGNORE_SIZE.includes(size)) {
                gridClass = "".concat(modifier).concat(base).concat(propValue);
              }

              classes.push(gridClass);
            } else classes.push("".concat(modifier).concat(base).concat(size));
          }
        }

        pushProp('', '');
        pushProp('Offset', 'offset-');
        pushProp('Push', 'push-');
        pushProp('Pull', 'pull-');
        pushProp('Hidden', 'hidden-');
      });
      classes.forEach(function (item) {
        item.toString();

        if (item.substring(0, 4) !== 'col-') {
          classes.unshift('col');
        }
      });
      if (classes.length === 0) classes.push('col');
      var ntClass = cx(_defineProperty({
        'w-100': breakline
      }, "align-self-".concat(alignSelf), alignSelf), classes, className);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: ntClass
      }, colProps), children);
    }
  }]);

  return Col;
}(Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;
Col.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Col",
  "props": {
    "alignSelf": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Columns will align according to one of the possible string value options: `['auto', 'start', 'end', 'center', 'baseline', 'stretch']`"
    },
    "breakline": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "xs": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "true",
          "computed": false
        }, {
          "value": "1",
          "computed": false
        }, {
          "value": "2",
          "computed": false
        }, {
          "value": "3",
          "computed": false
        }, {
          "value": "4",
          "computed": false
        }, {
          "value": "5",
          "computed": false
        }, {
          "value": "6",
          "computed": false
        }, {
          "value": "7",
          "computed": false
        }, {
          "value": "8",
          "computed": false
        }, {
          "value": "9",
          "computed": false
        }, {
          "value": "10",
          "computed": false
        }, {
          "value": "11",
          "computed": false
        }, {
          "value": "12",
          "computed": false
        }]
      },
      "required": false,
      "description": "Column span for device sizes: 0 - 575px.\n     Pass in a number from 1 to 12 or as a boolean."
    },
    "sm": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "true",
          "computed": false
        }, {
          "value": "1",
          "computed": false
        }, {
          "value": "2",
          "computed": false
        }, {
          "value": "3",
          "computed": false
        }, {
          "value": "4",
          "computed": false
        }, {
          "value": "5",
          "computed": false
        }, {
          "value": "6",
          "computed": false
        }, {
          "value": "7",
          "computed": false
        }, {
          "value": "8",
          "computed": false
        }, {
          "value": "9",
          "computed": false
        }, {
          "value": "10",
          "computed": false
        }, {
          "value": "11",
          "computed": false
        }, {
          "value": "12",
          "computed": false
        }]
      },
      "required": false,
      "description": "Column span for device sizes: 576 - 767px.\n     Pass in a number from 1 to 12 or as a boolean."
    },
    "md": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "true",
          "computed": false
        }, {
          "value": "1",
          "computed": false
        }, {
          "value": "2",
          "computed": false
        }, {
          "value": "3",
          "computed": false
        }, {
          "value": "4",
          "computed": false
        }, {
          "value": "5",
          "computed": false
        }, {
          "value": "6",
          "computed": false
        }, {
          "value": "7",
          "computed": false
        }, {
          "value": "8",
          "computed": false
        }, {
          "value": "9",
          "computed": false
        }, {
          "value": "10",
          "computed": false
        }, {
          "value": "11",
          "computed": false
        }, {
          "value": "12",
          "computed": false
        }]
      },
      "required": false,
      "description": "Column span for device sizes: 768 - 991px.\n     Pass in a number from 1 to 12 or as a boolean."
    },
    "lg": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "true",
          "computed": false
        }, {
          "value": "1",
          "computed": false
        }, {
          "value": "2",
          "computed": false
        }, {
          "value": "3",
          "computed": false
        }, {
          "value": "4",
          "computed": false
        }, {
          "value": "5",
          "computed": false
        }, {
          "value": "6",
          "computed": false
        }, {
          "value": "7",
          "computed": false
        }, {
          "value": "8",
          "computed": false
        }, {
          "value": "9",
          "computed": false
        }, {
          "value": "10",
          "computed": false
        }, {
          "value": "11",
          "computed": false
        }, {
          "value": "12",
          "computed": false
        }]
      },
      "required": false,
      "description": "Column span for device sizes: 992 - 1199px.\n     Pass in a number from 1 to 12 or as a boolean."
    },
    "xl": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "true",
          "computed": false
        }, {
          "value": "1",
          "computed": false
        }, {
          "value": "2",
          "computed": false
        }, {
          "value": "3",
          "computed": false
        }, {
          "value": "4",
          "computed": false
        }, {
          "value": "5",
          "computed": false
        }, {
          "value": "6",
          "computed": false
        }, {
          "value": "7",
          "computed": false
        }, {
          "value": "8",
          "computed": false
        }, {
          "value": "9",
          "computed": false
        }, {
          "value": "10",
          "computed": false
        }, {
          "value": "11",
          "computed": false
        }, {
          "value": "12",
          "computed": false
        }]
      },
      "required": false,
      "description": "Column span for device sizes: 1200px and above.\n     Pass in a number from 1 to 12 or as a boolean."
    },
    "xsHidden": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Hide column on xs"
    },
    "smHidden": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Hide column on sm"
    },
    "mdHidden": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Hide column on md"
    },
    "lgHidden": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Hide column on lg"
    },
    "xlHidden": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Hide column on xl"
    },
    "xsOffset": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Offset number for columns from the left for xs"
    },
    "smOffset": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Offset number for columns from the left for sm"
    },
    "mdOffset": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Offset number for columns from the left for md"
    },
    "lgOffset": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Offset number for columns from the left for lg"
    },
    "xlOffset": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Offset number for columns from the left for xl"
    },
    "xsPush": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Push columns for xs"
    },
    "smPush": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Push columns for sm"
    },
    "mdPush": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Push columns for md"
    },
    "lgPush": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Push columns for lg"
    },
    "xlPush": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Push columns for xl"
    },
    "xsPull": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Pull columns for xs"
    },
    "smPull": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Pull columns for sm"
    },
    "mdPull": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Pull columns for md"
    },
    "lgPull": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Pull columns for lg"
    },
    "xlPull": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Pull columns for xl"
    }
  }
};
export default Col;